<ng-select
        #select
        [items]="entries$ | async"
        bindLabel="name"
        bindValue="id"
        [(ngModel)]="selectedEntries"
        [loading]="loading"
        [multiple]="false"
        [clearable]="false">
  <ng-template ng-label-tmp let-item="item">
    <div>{{ item.code }} [{{ item.percentage }}%] - <small>{{ item.description }}</small></div>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
    <div>[{{ item.percentage }}%] {{ item.code }} - <small>{{ item.description }}</small></div>
  </ng-template>
</ng-select>

